import { ALL_BUY_IN_AMOUNTS } from '../constants/buyInConstants';
import { ALL_BUY_IN_RANGE_MULTIPLIERS } from '../types/sharedTypes';
export function getBuyInRangeAmounts(buyIn, buyInRange) {
    const rangeMultipliers = ALL_BUY_IN_RANGE_MULTIPLIERS[buyInRange];
    const [minMultiplier, maxMultiplier] = rangeMultipliers;
    const minBuyIn = Math.max(1, Math.round(buyIn * minMultiplier));
    const maxBuyIn = Math.min(ALL_BUY_IN_AMOUNTS[ALL_BUY_IN_AMOUNTS.length - 1], Math.round(buyIn * maxMultiplier));
    return [minBuyIn, maxBuyIn];
}
